<template>
  <div>
    <v-subheader class="mt-5">Schedule Plan</v-subheader>
    <v-card>
      <v-card-subtitle>Planned Schedule</v-card-subtitle>
      <v-card-text>
        <v-row v-for="(plan, index) in weekGroups.schedulePlan" :key="index">
          <v-col col="12" lg="4">
            <a @click="showWeeklyPlanner(plan, index)">Week {{index+1}}
            ({{ plan.dates.map( d => d.format('MMM Do')).join(', ') }})
            </a>
          </v-col>
          <v-col col="12" lg="8">
            <v-select
              outlined
              dense
              multiple
              chips
              v-model="plan.topics"
              :items="topics"
              item-text="name"
              item-value="id"
              :label="`Topics for week ${index+1}`"
              @change="planChanged = true"
              clearable
            >
              <template v-slot:selection="data">
                <v-chip
                  @click.prevent="selectedTopic(data.item)"
                  outlined
                  :key="data.item.id"
                  class="chip--select-multi ma-1"
                >{{ data.item.name }}</v-chip>
              </template>
            </v-select>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions v-if="planChanged">
        <v-spacer />
        <v-btn @click="updateSchedulePlan">Update Schedule Plan</v-btn>
        <v-spacer />
      </v-card-actions>
    </v-card>

    <v-dialog v-model="topicDialog" width="90%">
      <v-toolbar>
        <v-spacer/>
        <v-btn icon @click="topicDialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
        <course-topic :expandMaterials="true" :showActions="false" :course="course" :courseTopic="activeCourseTopic" :key="activeCourseTopic.topic.id"/>
    </v-dialog>

    <v-dialog persistent v-model="weekPlanDialog" width="90%">
      <v-toolbar>
        Weekly Planner
        <v-spacer/>
        <v-btn icon @click="weekPlanDialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
        <Week-plan :topics="activeWeekTopics" :courseSchedules="activeCourseSchedules" :key="activeWeekId"/>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import { rrulestr } from "rrule";
import * as scheduleUtils from "@/components/course/schedule.js";
const CourseTopic = () =>  import("@/components/course/CourseTopic.vue");
const WeekPlan = () =>  import("@/components/course/WeekPlan.vue");

export default {
  props: ["course", "editable"],
  data() {
    return {
      weekGroups: { startDate: null, endDate: null, schedulePlan: [] },
      planChanged: false,
      topicDialog: false,
      weekPlanDialog: false,
      activeCourseTopic: { topic: {id: 0}},
      activeWeekId: 0,
      activeWeekTopics: [],
      activeCourseSchedules: []
    };
  },
  computed: {
    ...mapGetters(["isAppLoading"]),
    topics() {
      const courseTopics = this.course.courseTopics;
      if (courseTopics && courseTopics.length > 0) {
        return courseTopics.map(ct => ct.topic);
      } else {
        return [];
      }
    }
  },
  components:{
    CourseTopic,
    WeekPlan
  },
  methods: {
    ...mapActions(["addSuccessMessage", "addErrorMessage"]),
    
    initSchedulePlans() {

      const rrules = this.course.courseSchedules.map(cs => cs.rrule);

      let scheduledDates = []
      rrules.forEach( (rrule) => {
        if(rrule){
          scheduledDates = [...scheduledDates, ...rrulestr(rrule).all(function (date, i){return i < 300})];
        }
      });

      const singleDates = this.course.courseSchedules.filter(cs => !cs.rrule).map(cs => moment(cs.startDate).toDate());
      scheduledDates = [...scheduledDates, ...singleDates];

      console.log("grouping schedule dates to weeks");
      this.weekGroups = scheduleUtils.groupSchedulesByWeeks(scheduledDates);

      const weeksWithSchedules = this.weekGroups.schedulePlan.map(wg => {
        //match date with course schedule ID
        let scheduleIds = wg.dates.map(d => {
          const schedule = this.course.courseSchedules.find(cs =>
            moment(cs.start).isSame(d, "date")
          );
          if(schedule){
            return schedule.id;
          }
          else{
            return null;
          }
        });

        scheduleIds = scheduleIds.filter(id => id != null);

        return { scheduleIds, ...wg };
      });

      this.weekGroups.schedulePlan = weeksWithSchedules;

      //assign topic to schedule
      this.weekGroups.schedulePlan.forEach(week => {
        let weekTopicIds = new Set();
        week.scheduleIds.forEach(sid => {
          const courseSchedule = this.course.courseSchedules.find(
            cs => cs.id == sid
          );
          if (courseSchedule["schedule.topicSchedule"]) {
            weekTopicIds = [
              ...weekTopicIds,
              ...courseSchedule["schedule.topicSchedule"].map(ts => ts.topicId)
            ];
          }
        });

        week.topics = [...new Set(weekTopicIds)];
      });

      console.log(this.weekGroups);
    },
    updateSchedulePlan() {
      console.log(this.weekGroups.schedulePlan);
      const scheduleToTopics = [];
      this.weekGroups.schedulePlan.forEach(element => {
        element.scheduleIds.forEach(s => {
          scheduleToTopics.push({
            courseScheduleId: s,
            topicIds: element.topics
          });
        });
      });

      // construct request to link schedule to topics
      const data = { scheduleToTopics };
      this.$axios.post("/course/link-topic-course-schedule", data).then(() => {
        this.addSuccessMessage("Schedule updated");
        this.planChanged = false;
      });
    },
    selectedTopic(topic) {
      console.log("selected chip");
      console.log(topic);
      const courseTopic = this.course.courseTopics.find(ct => ct.topic.id == topic.id);
      this.topicDialog = true;
      this.activeCourseTopic = courseTopic;
    },
    showWeeklyPlanner(plan, index){
      console.log(plan)
      const weekScheduleIds = plan.scheduleIds || [];
      this.activeCourseSchedules = this.course.courseSchedules.filter( cs => weekScheduleIds.includes(cs.id) );
      this.activeWeekId = index;
      this.weekPlanDialog = true;

      const weekTopicIds = plan.topics || [];
      this.activeWeekTopics = this.course.courseTopics.filter(ct => weekTopicIds.includes(ct.topic.id)).map( ct => ct.topic );
    }
  },
  mounted() {
    this.initSchedulePlans();
  }
};
</script>

<style>
</style>